<template>
  <div v-if="showBanner" class="courses-banner">
    <el-carousel ref="courseBannerRef" class="courses-carousel-banner" :interval="10000" :indicator-position="bannerList.length === 1 ? 'none' : '' " :arrow="bannerList.length > 1 ? 'hover' : 'never'" height="200px" @change="onChange">
      <el-carousel-item v-for="(item, index) in bannerList" :key="index">
        <div class="courses-banner-img" :style="{'backgroundImage':`url(${item.src})`}">
          <a v-if="item.url" class="img-link" :href="item.url" :target="item.target ? '_blank' : ''" aria-label="Course Banner" @click="handleClick(item)" />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  mixins: [mixin],
  watch: {
    showBanner(value) {
      if (value) {
        this.$nextTick(() => {
          this.btnAriaLabel()
        })
      }
    },
  },
  methods: {
    btnAriaLabel() {
      const bannerRefList = Array.from(document.getElementsByClassName('el-carousel__button'))
      bannerRefList.map((item) => item.setAttribute('aria-label', 'Banner Change Button'))
    },
  },
}
</script>

<style lang="scss">
.courses-banner {
  width: 1240px;
  height: 200px;
  margin: 0 auto 30px auto;
  border-radius: 16px;
  overflow: hidden;

  .el-carousel__arrow {
    background: #000;
    opacity: 0.4;

    i {
      font-weight: bold;
      font-size: 16px;
    }
  }

  .el-carousel__arrow--left {
    left: 20px;
  }

  .el-carousel__arrow--right {
    right: 20px;
  }

  .el-carousel__item {
    width: 100%;
    height: 200px;

    img {
      width: 100%;
      height: 100%;
    }

    .courses-banner-img {
      display: block;
      width: 100%;
      height: 100%;
      font-size: 0;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;

      a {
        display: block;
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }
  }

  .courses-carousel-banner .el-carousel__indicators.el-carousel__indicators--horizontal {
    bottom: 20px;

    .el-carousel__indicator.el-carousel__indicator--horizontal {
      margin: 0 3px;
      padding: 0 0;

      .el-carousel__button {
        width: 6px;
        height: 6px;
        border-radius: 100%;
        background: rgba(255, 255, 255, 0.8);
      }

      &.is-active {
        .el-carousel__button {
          width: 40px;
          border-radius: 3px;
          background: #fff;
        }
      }
    }
  }
}

</style>
